import { getErrorMessageFromErrorType } from '@flowwai-frontend/shared/utils/common'
import { ThreadMessage } from '@flowwai-frontend/bps-officer-web/graphql'
import { MessageModel } from '@flowwai-frontend/shared-web/ai-chat-support/data-access'

import { convertGqlMessageTypeToLocalMessageType } from '../../factories/threadMessageFactories'

import { GetMessagesForThreadQuery as Query } from './query.generatedTypes'

interface ArgsType {
   data: Query | undefined
   onSuccess?: (messageModels: MessageModel[], totalCount: number) => void
   onHandleError?: (
      errorMessage: string,
      data: Query['getMessagesForThread']
   ) => void
}

const useResponseHandler = () => {
   const handleAPIResponse = (args: ArgsType): void => {
      if (!args.data) return
      const responseData = args.data.getMessagesForThread

      switch (responseData?.__typename) {
         case 'GetMessagesForThreadResult': {
            const messages: MessageModel[] = []
            responseData.messages.forEach(message => {
               const formattedMessageData = convertGqlMessageTypeToLocalMessageType(
                  message as ThreadMessage
               )
               const messageModel = MessageModel.create(formattedMessageData)
               messages.push(messageModel)
            })
            args.onSuccess?.(messages, responseData.totalCount)

            break
         }
         case 'InvalidLimit':
         case 'InvalidOffset':
         default: {
            const errorMessage = getErrorMessageFromErrorType(
               responseData?.__typename
            )
            args.onHandleError?.(errorMessage, responseData)
         }
      }
   }

   return {
      handleAPIResponse
   }
}

export default useResponseHandler
